import * as t from "io-ts"
import { UnexpectedValueError } from "../../../unexpected-value-error";

interface ScoreBrand {
    readonly Score: unique symbol;
}
export const Score = t.brand(t.number,
    (n): n is t.Branded<number, ScoreBrand> => true,
    "Score"
);
export type Score = t.TypeOf<typeof Score>;

export function createScore(value: number): Score {
    return UnexpectedValueError.throwIfLeft("score", 
        Score.decode(value));
}

export function addToScore(current: Score, value: Score): Score {
    return createScore(current + value);
}

export const zeroScore = createScore(0);
